

import React, { useEffect, useContext } from "react";
import { SessionContext } from "./state/SessionContext";

import { StarFill, JournalCheck, ExclamationTriangle, TagFill } from "react-bootstrap-icons";
import { SESSION_ACTIONS } from "./state/SessionReducer";
import { useTranslation } from "react-i18next";
import i18n from "i18next";
import { Cards, CurrencySign, GameSpecialtyIcons, GameStructureIcons, GameVariantIcons, getCardColor, getCardText, nFormatter, RoomTypeIcons } from "../../api/ReplayVariables";
import FormattedDuration from "react-intl-formatted-duration";

function SessionCell({row, match, column, compacted}){

    const { sessionState, dispatchSessionState  } = useContext(SessionContext);

    const { t } = useTranslation();

    const openRow = () => {
      dispatchSessionState({
        type: SESSION_ACTIONS.OPEN_ROW,
        sessionId: row.id,
        heroId : match.params.hero
      });
    };

    const openNotes = () => {
      //sendCommand("session/replay", {sessionId : row.id, heroId : 0});
    };
    const toggleBookmark = () => {
      dispatchSessionState({
        type: SESSION_ACTIONS.TOGGLE_BOOKMARKS,
        ids: [row.id],
        bookmark : !row.bookmark
      });
    };
    
  
    useEffect(()=>{
        //console.log("SessionCell effect");

        return (()=>{
            //console.log("SessionCell effect done");
        });
    }, []);

    switch(column.name){
      case "problem":{
        return (row.dataProblem ? <ExclamationTriangle
          size="16"
          onClick={() => openRow()}
        ></ExclamationTriangle> : <></>)
      }
      case "bookmark":{
        return (
        <StarFill
          size="16"
          className={"bookmark" + (row.bookmark ? " bookmarked" : "")}
          onClick={() => toggleBookmark()}
        ></StarFill>
        )
      }
      case "notes":{
        return (
          <JournalCheck
          size="16"
          className={"notes" + (row.notes ? " noted" : "")}
          onClick={() => openNotes()}
        ></JournalCheck>
        )
      }
      case "site":{
        return (
          <img src={RoomTypeIcons[row.roomType]} alt={row.roomType} />
        )
      }
      case "day_of_week":{
        return (
          t("app.daysOfWeek." + row.dayOfWeek)
        )
      }
      case "date":{
        let seconds = (Date.parse(row.endDate) - Date.parse(row.startDate)) / 1000;
        //console.log(Date.parse(row.endDate)-Date.parse(row.startDate)+ ":" + seconds );
        return !compacted ? (
          new Intl.DateTimeFormat(i18n.language, {
            year: "numeric",
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit"
          }).format(Date.parse(row.startDate))
        ) : (
          <>
            {new Intl.DateTimeFormat(i18n.language, {
              year: "2-digit",
              month: "short",
              day: "2-digit",
              hour: "2-digit",
              minute: "2-digit"
            }).format(Date.parse(row.startDate))}
            <br />
            <div className="details">
              {seconds >= 60 ? (
                <FormattedDuration
                  seconds={seconds}
                  format="{hours} {minutes}"
                  unitDisplay="narrow"
                />
              ) : (
                <FormattedDuration
                  seconds={seconds}
                  format="{seconds}"
                  unitDisplay="narrow"
                />
              )}{" "}
              - {row.nbHands}{" "}
              {t(row.nbHands > 1 ? "app.session.columns.nbHands.name" : "app.session.columns.nbHands.name_singular").toLowerCase()}
            </div>
          </>
        );
    }
    case "category":{
      return <TagFill size="16" style={{ color: row.category >= 0?row.categoryColor:"transparent" }}></TagFill>;
    }
    case "name":{
      if (!compacted) {
        return row.htmlname;
      } else {
        if (match.params.sessionType === 1) {
          let html = "";
          if (row.buyInWithRake !== 0 || row.currency !== "PLAYMONEY") {
            if (row.rake > 0) {
              html += nFormatter(row.buyInWithRake - row.rake) + "+" + nFormatter(row.rake) + " " + CurrencySign[row.currency];
            } else {
              html += nFormatter(row.buyInWithRake) + " " + CurrencySign[row.currency];
            }
          } else {
            html += t("currency.-2");
          }
          let nbRebuysAddons = row.nbRebuys;

          if (nbRebuysAddons > 0) {
            if (row.getRebuy() === 0) {
              html += "&nbsp; + " + nbRebuysAddons + "x" + nFormatter(row.buyInWithRake);
            } else {
              html += "&nbsp; + " + nbRebuysAddons + "x" + nFormatter(row.getRebuy());
            }
          }
          if (row.prizepool > 0) {
            html += " - " + t("app.session.columns.prizepool.name") + " : " + nFormatter(row.prizepool) + " " + CurrencySign[row.currency];
          }
          if (row.nbPlayers >= 2)
            html += " - (" + row.nbPlayers + " " + t("app.session.columns.nbplayers.name") + ")";
          else
            html += " - (" + t("app.session.columns.nbplayers.unknown") + ")";


          return <div className="d-flex">
            <div>
              {row.htmlname}
              <br />
              <span className="details">{html}
              </span>
            </div>
          </div>;
        } else {
          let html = "";
          if (row.bbCashGame === 0.05) {
            html = "0.02/0.05 " + CurrencySign[row.currency];
          } else {
            html = nFormatter(row.bbCashGame / 2) + " / " + nFormatter(row.bbCashGame) + " " + CurrencySign[row.currency];
          }
          return <div className="d-flex">
            <div>
              {row.htmlname}
              <br />
              <span className="details">{html}
              </span>
            </div>
          </div>;
        }
      }
    }
    case "time_spent":{
      let seconds = (Date.parse(row.endDate) - Date.parse(row.startDate)) / 1000;
      if (seconds >= 60)
        return (
          <FormattedDuration
            seconds={seconds}
            format="{hours} {minutes}"
            unitDisplay="narrow"
          />
        );
      else
        return (
          <FormattedDuration
            seconds={seconds}
            format="{seconds}"
            unitDisplay="narrow"
          />
        );
    }
    case "nbHands":{
      return <>{row.nbHands}</>;
    }
    case "game_format":{
      return !compacted ? (
        <div>{row.nbSeats}</div>
      ) : (
        <>
          <div>{row.nbSeats}</div>
          <img src={GameVariantIcons[row.gameVariant]} alt={row.gameVariant} />
        </>
      );
    }
    case "game_variant":{
      return <img src={GameVariantIcons[row.gameVariant]} alt={row.gameVariant} />;
    }
    case "structure_type":{
      return !compacted ? (
        <img src={GameStructureIcons[row.structureType]} alt={row.structureType} />
      ) : (
        <>
          <img src={GameStructureIcons[row.structureType]} alt={row.structureType} />
          <br />
          <img src={GameSpecialtyIcons[row.gameSpecialty]} alt={row.gameSpecialty} />
        </>
      );
    }
    case "special_type":{
      return <img src={GameSpecialtyIcons[row.gameSpecialty]} alt={row.gameSpecialty} />;
    }
    case "buyin":{
      let html = "";
      if (row.buyInWithRake >= 0) {
        if (row.buyInWithRake !== 0 || row.currency !== "PLAYMONEY") {
          if (row.rake > 0) {
            html += nFormatter(row.buyInWithRake - row.rake) + "+" + nFormatter(row.rake) + " " + CurrencySign[row.currency];
          } else {
            html += nFormatter(row.buyInWithRake) + " " + CurrencySign[row.currency];
          }
        } else {
          html += " ";//t("row.currency.-2");
        }
        let nbRebuysAddons = row.nbRebuys;
        html += "";
        if (nbRebuysAddons > 0) {
          if (row.rebuy === 0) {
            html += " + " + nbRebuysAddons + "x" + nFormatter(row.buyInWithRake);
          } else {
            html += " + " + nbRebuysAddons + "x" + nFormatter(row.rebuy);
          }
        }
      } else {
        html += "-";
      }
      return html;
    }
    case "prizepool":{
      let html = "";
      if (row.prizepool > 0) {
        html += nFormatter(row.prizepool) + " " + CurrencySign[row.currency];
      }
      return html;
    }
    case "nbplayers":{
      let html = "";
      if (row.nbPlayers >= 2) {
        html += row.nbPlayers;
      }
      return html;
    }
    case "finish":{
      if (compacted) {
        if (row.nbPlayers > 10000 || row.finish > 10000) {
          if (row.finish > 0 && (row.nbPlayers <= 0 || row.finish <= row.nbPlayers)) {
            if (row.nbPlayers > 1) {
              return <><b>{row.finish}</b> / {row.nbPlayers}</>;
            } else {
              return <><b>{row.finish}</b> / -</>;
            }
          } else if (row.finish > row.nbPlayers) {
            if (row.nbPlayers > 1) {
              return <><b>?</b> / {row.nbPlayers}</>;
            } else {
              return <><b>?</b> / -</>;
            }
          } else {
            if (row.nbPlayers > 1) {
              return <><b>-</b> / {row.nbPlayers}</>;
            } else {
              return <><b>-</b> / -</>;
            }
          }
        } else {
          if (row.finish > 0 && (row.nbPlayers <= 0 || row.finish <= row.nbPlayers)) {
            if (row.nbPlayers > 1) {
              return <><b>{row.finish}</b> / {row.nbPlayers}</>;
            } else {
              return <><b>{row.finish}</b> / -</>;
            }
          } else if (row.finish > row.nbPlayers) {
            if (row.nbPlayers > 1) {
              return <><b>?</b> / {row.nbPlayers}</>;
            } else {
              return <><b>?</b> / -</>;
            }
          } else {
            if (row.nbPlayers > 1) {
              return <><b>-</b> / {row.nbPlayers}</>;
            } else {
              return <><b>-</b> / -</>;
            }
          }
        }
      } else {
        if (row.finish > 0 && (row.nbPlayers <= 0 || row.finish <= row.nbPlayers)) {
          return row.finish;
        } else if (row.finish > row.nbPlayers) {
          return "?";
        } else {
          return "-";
        }

      }
    }
    case "gain":{
      if (row.totalBounty > 0) {
        if (row.gain > 0) {
          return <><div className="ok"></div>{nFormatter(row.gain)} { CurrencySign[row.currency]}<br />KO={nFormatter(row.totalBounty)} {CurrencySign[row.currency]}</>;
        } else if (row.gain === 0) {
          if (row.dataProblem) {
            return <><div className="disabled"></div>{nFormatter(row.gain)} {CurrencySign[row.currency]}<br />KO={nFormatter(row.totalBounty)} {CurrencySign[row.currency]}</>;
          } else {
            return <><div className="ko"></div>{nFormatter(row.gain)} {CurrencySign[row.currency]}<br />KO={nFormatter(row.totalBounty)} {CurrencySign[row.currency]}</>;
          }
        }
      } else {
        if (row.gain > 0) {
          return <><div className="ok"></div>{nFormatter(row.gain)} { CurrencySign[row.currency]}</>;
        } else if (row.gain === 0) {
          if (row.dataProblem) {
            return <><div className="disabled"></div>{nFormatter(row.gain)} { CurrencySign[row.currency]}</>;
          } else {
            return <><div className="ko"></div>{nFormatter(row.gain)} { CurrencySign[row.currency]}</>;
          }
        } else {
          return <></>;
        }
      }
      return <></>;
    }
    case "netgain":{
      let amountNet = row.netGain;
      if (!row.dataProblem) {
        if (amountNet > 0) {
          return <><div className="ok"></div>+{nFormatter(amountNet)} { CurrencySign[row.currency]}</>;
        } else if (amountNet < 0) {
          return <><div className="ko"></div>{nFormatter(amountNet)} { CurrencySign[row.currency]}</>;
        } else {
          return <><div className="disabled"></div>{nFormatter(amountNet)} { CurrencySign[row.currency]}</>;
        }
      } else {
        return <><div className="disabled"></div>{nFormatter(amountNet)} { CurrencySign[row.currency]}</>;
      }
    }
    case "limit":{
      return nFormatter(row.bbCashGame / 2) + " / " + nFormatter(row.bbCashGame) + " " + CurrencySign[row.currency];
    }
    case "rake":{
      return nFormatter(row.rake) + " " + CurrencySign[row.currency];
    }
    case "netgain_vshero":{
      if (!row.heroData) {
        let amountNet = row.netChipsVsHero;
        if (amountNet > 0) {
          return <><div className="ok"></div>+{nFormatter(amountNet)} {CurrencySign[row.currency]}</>;
        } else if (amountNet < 0) {
          return <><div className="ko"></div>{nFormatter(amountNet)} {CurrencySign[row.currency]}</>;
        } else {
          return <><div className="disabled"></div>{nFormatter(amountNet)} {CurrencySign[row.currency]}</>;
        }
      }
      return <></>;
    }
    case "netgain_ev":{
      if (!row.dataProblem) {
        let amountNet = row.netChipsEV;
        if (amountNet > 0) {
          return <><div className="ok"></div>+{nFormatter(amountNet)} {CurrencySign[row.currency]}</>;
        } else if (amountNet < 0) {
          return <><div className="ko"></div>{nFormatter(amountNet)} {CurrencySign[row.currency]}</>;
        } else {
          return <><div className="disabled"></div>{nFormatter(amountNet)} {CurrencySign[row.currency]}</>;
        }
      }
      return <></>;
    }
    case "last_hand":{
      if (compacted) {
        if (row.gameVariant.indexOf("HOLD_EM") !== -1) {
          if (row.percentage >= 0) {
            return <div><div className="color" style={{ backgroundColor: row.handColor }}></div><img src={Cards["card" + row.card1]} alt="" /><img src={Cards["card" + row.card2]} alt="" /> <div className="percentage">{row.percentage}%</div></div>;
          } else {
            return <div><div className="color" style={{ backgroundColor: row.handColor }}></div><img src={Cards["card" + row.card1]} alt="" /><img src={Cards["card" + row.card2]} alt="" /></div>;
          }
        } else {
          if (row.percentage >= 0) {
            return <div><div className="color" style={{ backgroundColor: row.handColor }}></div><img src={Cards["card" + row.card1]} alt="" /><img src={Cards["card" + row.card2]} alt="" /><img src={Cards["card" + row.card3]} alt="" /><img src={Cards["card" + row.card4]} alt="" /> <div className="percentage">{row.percentage}%</div></div>;
          } else {
            return <div><div className="color" style={{ backgroundColor: row.handColor }}></div><img src={Cards["card" + row.card1]} alt="" /><img src={Cards["card" + row.card2]} alt="" /><img src={Cards["card" + row.card3]} alt="" /><img src={Cards["card" + row.card4]} alt="" /></div>;
          }
        }
      } else {
        if (row.gameVariant.indexOf("HOLD_EM") !== -1) {
          if (row.percentage >= 0) {
            return <><div className="color" style={{ backgroundColor: row.handColor }}></div><div className={getCardColor(row.card1)}>{getCardText(row.card1)}</div><div className={getCardColor(row.card2)}>{getCardText(row.card2)}</div> <div className="percentage">{row.percentage}%</div></>;
          } else {
            return <><div className="color" style={{ backgroundColor: row.handColor }}></div><div className={getCardColor(row.card1)}>{getCardText(row.card1)}</div><div className={getCardColor(row.card2)}>{getCardText(row.card2)}</div></>;
          }
        } else {
          if (row.percentage >= 0) {
            return <><div className="color" style={{ backgroundColor: row.handColor }}></div><div className={getCardColor(row.card1)}>{getCardText(row.card1)}</div><div className={getCardColor(row.card2)}>{getCardText(row.card2)}</div><div className={getCardColor(row.card3)}>{getCardText(row.card3)}</div><div className={getCardColor(row.card4)}>{getCardText(row.card4)}</div> <div className="percentage">{row.percentage}%</div></>;
          } else {
            return <><div className="color" style={{ backgroundColor: row.handColor }}></div><div className={getCardColor(row.card1)}>{getCardText(row.card1)}</div><div className={getCardColor(row.card2)}>{getCardText(row.card2)}</div><div className={getCardColor(row.card3)}>{getCardText(row.card3)}</div><div className={getCardColor(row.card4)}>{getCardText(row.card4)}</div></>;
          }
        }

      }
    }
    default:{
        return <>{column.name}</>
      }
    }
}
export default SessionCell;